import { NB } from '@cerebral-inc/ui';
import { ContactWrapper } from './styled';

const { Flex, Text, Link } = NB;

const TelephoneLink = ({ text }: { text: string }): JSX.Element => (
  <Link href={`tel:${text}`}>
    <Text underline color="#385ADE" fontWeight="semibold" fontFamily="Poppins">
      {text}
    </Text>
  </Link>
);

const Anchor = ({ href, text }: { href: string; text: string }) => (
  <Link
    href={href}
    lineHeight="20px"
    _text={{
      color: '##385ADE',
      fontSize: '14px',
      fontWeight: 600,
      fontFamily: 'Poppins'
    }}
  >
    {text}
  </Link>
);

const EmergencyHelp = () => {
  return (
    <Flex justifyContent="center" alignItems="center">
      <Text
        fontFamily="Poppins"
        color="#1C1E21"
        fontSize="24px"
        fontWeight={600}
        lineHeight="28px"
        textAlign="center"
      >
        Here’s how to get emergency help.
      </Text>
      <Text
        fontFamily="Poppins"
        color="#353A41"
        fontSize="16px"
        lineHeight="24px"
        textAlign="center"
        mt={{ base: '36px', sm: '48px' }}
      >
        If you think you may hurt yourself, someone else, or plan to end your
        life — this is a mental health emergency.
      </Text>
      <Text
        fontFamily="Poppins"
        color="#353A41"
        fontSize="16px"
        fontWeight={600}
        lineHeight="24px"
        textAlign="center"
        mt="8px"
      >
        Please get help as soon as possible.
      </Text>
      <Flex
        maxW="488px"
        p="16px"
        borderRadius="8px"
        backgroundColor="#FEF4DB"
        mt={{ base: '36px', sm: '48px' }}
      >
        <Text
          fontFamily="Poppins"
          color="#353A41"
          fontSize="16px"
          lineHeight="24px"
        >
          <ContactWrapper>
            <li>
              <Text fontWeight={600}>Call</Text>{' '}
              <Text
                fontWeight={600}
                color="#385ADE"
                textDecorationLine="underline"
              >
                911&nbsp;
              </Text>
              or go to your nearest&nbsp;
              <Text fontWeight={600}>emergency room.</Text>
            </li>
            <li>
              Call or text <TelephoneLink text="988" />{' '}
              <NB.Text fontWeight="semibold">Suicide & Crisis Lifeline</NB.Text>
              . Chat service is available at{' '}
              <Anchor href="988lifeline.org" text="988lifeline.org" />.
            </li>
            <li>
              Text <Text fontWeight={600}>HOME</Text> to&nbsp;
              <Text
                fontWeight={600}
                color="#385ADE"
                textDecorationLine="underline"
              >
                741-741
              </Text>
              &nbsp;for Crisis Text Line to get free and confidential help 24/7.
            </li>
          </ContactWrapper>
        </Text>
      </Flex>
      <Text
        fontFamily="Poppins"
        color="#4D515A"
        fontSize="16px"
        lineHeight="24px"
        textAlign="center"
        my={{ base: '36px', sm: '48px' }}
      >
        If you are not currently experiencing an emergency, you can find
        long-term support at Cerebral.
      </Text>
    </Flex>
  );
};

export default EmergencyHelp;
